import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import "./search.css"
const { API_KEY } = process.env
const API_URL = 'https://uvunebeta.herokuapp.com/users'

class Search extends Component {
  constructor(props){
    super(props)
    this.state = {
      query: '',
      results : [],
      hideImage:false,
      hideData:false,
      getSearch : true,
      noerorrpage :  true
    }

  }

  componentWillMount(){
    this.props.noerorrpage(this.state.noerorrpage)
    this.setState({
        getSearch : true
      })
    }


  getInfo = () => {
    
    // fetch(`${API_URL}?search=${this.state.query}`)
    fetch(`${API_URL}?display_name[$search]=${this.state.query}`)
    .then(res => res.json())
      .then(({ data }) => {
        this.setState({
          results: data,// MusicGraph returns an object named data, 
          hideImage : true     ,              // as does axios. So... data.data  
          hideData:true    ,
          getSearch : true                       
        })
      })

      console.log("results", this.state.results)
  }

 
  handleInputChange = () => {
    this.setState({
      getSearch : false,
    })
    console.log("search", this.state.getSearch)
    this.setState({
      
      query: this.search.value
    },() => {
      if (this.state.query && this.state.query.length > 0) {
       
        if (this.state.query.length % 2 === 0) {
          this.setState({
            getSearch : true,
          })
          this.getInfo()
        }
      } 
    })
    console.log("search", this.state. query)
  }

  closeData = ()=>{
    this.setState({
      hideData:false
    })
  }

  render() {
    
    return (
            <div className="Search"> 
               <div className="search-body-radus-sub">
                  {  this.state.hideImage ?
                      <div className="image-serach-hide"> 
                        <br/>
                        <br/>
                      </div> :
                      <div className="search-add-body">
                          <img   src="http://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png"  />
                      </div>
                  }
                    
                    <div className="search-body-input">
                        <div className="control has-icons-right">
                              <input className="input is-medium" type="email" ref={input => this.search = input}   onChange={this.handleInputChange} placeholder="Enter school name or  phone number "/>
                              <span className="icon is-right">
                                <i className="fas fa-search"></i>
                              </span>
                          </div>
                    </div>  

                    <div>
                      {
                        this.state.getSearch ?
                           <div>
                           </div>
                           :
                          
                           <span>
                               <div className="level-item">
                                  <a className="button is-loading is-large is-light">Loading</a>
                               </div>
                          </span>
                      }

                     </div> 
                   
                    <div className="search-list-full-body">
                      {  this.state.hideData &&  this.state.results.length > 0 ? (
                                    <div className="close-button-search">   <button className="delete is-small  is-danger" onClick={this.closeData}></button> </div> 
                              ):     
                                    <samp> </samp>
                          }
                    {  this.state.hideData &&  this.state.results.length > 0 ? (
                          <div className="mydive">
                          
                        
                                <div>
                                  {
                                    this.state. results.map(item=>{   return(
                                      <Link to={`/home/${item._id}`}  key={item._id} href="#">   
                                      <div className="search-data-body" >
                                        <ul className="search-list-body">
                                            <li className="search-list-li" >
                                                { item.image_url?
                                                  <div>
                                                    {
                                                      item.image_url == "" ?
                                                      <img src="http://macmaplegrove.com/wp-content/uploads/2016/01/MGS-logo.png"/>   
                                                      :
                                                      <img src={ item.image_url} />
                                                    }
                                                                
                                                 </div> :
                                                 <div><img src="http://macmaplegrove.com/wp-content/uploads/2016/01/MGS-logo.png" /></div>            
                                                }
                                              {/* <img src="http://macmaplegrove.com/wp-content/uploads/2016/01/MGS-logo.png" /> */}

                                              <h3 className="serach-h3-para">{item.display_name}</h3>
                                              <p><i className="fas fa-map-marker-alt "></i> {item.address} </p>
                                            </li>
                                        </ul>
                                      </div> 
                                    </Link>  
                                    )
                                    })
                                  }
                              </div>  
                          
                         
                          
                       </div> 
                         ):
                         <div> </div>  
                    }
                  </div>
               
                 
                  {  this.state.hideImage ?
                   <div>
                     <br/>
                     <br/>
                     <br/>
                   </div>
                    
                  :
                  <div className="divider-search-body">
                        <div className="add-image-search">
                            <img   src="http://res.cloudinary.com/easywaya/image/upload/v1535448295/1fcb38eb-fed4-47ca-abbe-babab288e041_p5mphs.jpg"  />  
                        </div>  
                   </div> 
                  }
          </div>


          <div className="search-featur-body">
              <div className="search-featur-body-sub">
                  <div className="columns">
                      <div className="column is-one-third">
                           <div className="search-featur-data">
                           <i className="fas fa-school search-font-info"></i>
                                  <h4 className="search-featur-data-title">Education</h4>
                                  <br/>
                                  <p className="search-featur-data-para">From convenient payment methods to payment plans, Uvune is your one-stop-shop for payment solutions.</p>
                           </div>
                      </div>
                      <div className="column">
                           <div className="search-featur-data">
                              <i className="fas fa-hand-holding-usd search-font-info"></i>
                                  <h4 className="search-featur-data-title">
                                  Flexible, local
                                   payment methods
                                  </h4>
                                 
                                  <br/>
                                  <p className="search-featur-data-para">
                                  We're constantly expanding our international network to provide optimal and familiar payment options.
                                  </p>
                           </div>
                      </div>
                      <div className="column">
                           <div className="search-featur-data">
                                <i className="fas fa-money-bill search-font-info"></i>
                                  <h4 className="search-featur-data-title">Payment</h4>
                                 
                                  <br/>
                                  <p className="search-featur-data-para">
                                  Payment
                                   Uvune sends funds to institutions via batch disbursements with easy reconciliation
                                  </p>
                           </div>
                      </div>
                  </div>
              </div>

          </div>
           <div className="search-getStarted-body">
                 <div className="search-getStarted-sub">
                   <div className="columns">
                      <div className="column is-half">
                        <h4 className="search-Paragraph-Title">Check invoice  if make payment  </h4>
                            <a href="/bill" className="button is-success is-medium">
                              <span className="icon is-medium">
                                <i className="fas fa-arrow-right"></i>
                              </span>
                              <span>Get Invoice</span>
                            </a>
                    
                      </div>
                      <div className="column">
                      <h4 className="search-Paragraph-Title">Search for school to make payment  </h4>
                          <a href="#" className="button is-success is-medium">
                              <span className="icon is-medium">
                                <i className="fas fa-arrow-right"></i>
                              </span>
                              <span>Make search</span>
                            </a>
                      </div>
                      
                    </div>
                 </div>
          </div>
          <div className="search-about-data-body">
             <div className="search-about-data-sub">
                <div className="columns">
                    <div className="column is-half">
                          <h2 className="search-about-data-title">About our platform</h2>
                          <p>Uvune trusted and secure global payment platform keeps your money moving around
                             fast. With our custom solutions, robust collections network, and first-class support,
                              we streamline your payments process from start to finish. <br/><br/>
                           <a href="platform" title="About our platform">Know more</a>
                           </p>
                    </div>
                    <div className="column">
                      <div className="serach-image-about-title">
                           <img src="https://res.cloudinary.com/easywaya/image/upload/v1549107277/Uvine_Illustration_New_New_3_ky7g4g.png" width="300" />
                      </div>
                      
                    </div>
                  
                </div>
             </div>
          </div>

          <div className="search-getStarted-body">
                 <div className="search-getStarted-sub">
                   <div className="columns">
                      <div className="column is-two-thirds">
                        <h4 className="search-Paragraph-Title">Grow your international business today</h4>
                        
                    
                      </div>
                      <div className="column">
                          <a href="/signup" className="button is-success is-medium">
                              <span className="icon is-medium">
                                <i className="fas fa-arrow-right"></i>
                              </span>
                              <span>Get started</span>
                            </a>
                      </div>
                      
                    </div>
                 </div>
          </div>
               
          <div className="how-to-used-body">
                <header className="header">
                <div className="divider-search-sub"> 
                  <div className="search-sponsure-body">
                        <img src="https://technext.github.io/mobapp/images/client-logos.png"/>
                        {/* <ul className="search-sponsure-sub">
                          <li>kjxtgnkjbrnkj </li>
                          <li>kjxtgnkjbrnkj </li>
                      </ul> */}
                  </div>  
              </div>
                    <div className="brand-box">
                      <span className="brand">Uvune</span>
                    </div>
                    
                    <div className="text-box">
                      <h1 className="heading-primary">
                        <span className="heading-primary-main">Uvune Let Make Payment Easy</span>
                        <span className="heading-primary-sub">The secondary heading</span>
                      </h1>
                      <a href="#" className="btn btn-white  btn-animated">Make Search now</a>
                    </div>
                </header>

          </div>  
          <footer className="footer">
          
          <div className="search-footer-body-full">
            <div className="columns">
              <div className="column ">
                 <div className="search-footer-body">
                    <h5 className="search-footer-Menu-Title">Uvune</h5>
                    <br/>
                    <ul className="search-footer-Menu-list" >
                   
                      <li><a href="http://uvune.com/about/" target="_blank">About</a></li>
                      {/* <li>Careers</li> */}
                      {/* <li>Contact</li> */}
                      <li><a href="#" target="_blank"> Terms of Use </a></li>
                      {/* <li>Privacy Policy</li>
                      <li>Security Policy</li> */}
                    </ul>  
                 </div>
              </div>
              <div className="column">
                 <h5 className="search-footer-Menu-Title">Solutions</h5>
                    <br/>
                    <ul className="search-footer-Menu-list" >
                      <li>Education</li>
                      {/* <li>Healthcare</li>
                      <li>Business</li>
                      <li>Platform</li> */}
                    
                    </ul> 
              </div>
              <div className="column">
                 <h5 className="search-footer-Menu-Title">Community</h5>
                    <br/>
                  <ul className="search-footer-Menu-list" >
                      <li>Blog & News</li>
                      {/* <li>Engineering</li> */}
                      <li><a href="https://mobile.twitter.com/UvuneT" target="_blank">Twitter</a></li>
                      <li><a href="https://m.facebook.com/uvune/?notif_t=page_admin&ref=m_notif" target="_blank">Facebook</a></li>
                      <li><a href="https://www.instagram.com/uvune_tech/" title="Linkedin"  >Instagram</a></li>
                      
                  </ul> 
              </div>
              <div className="column">
                  <h5 className="search-footer-Menu-Title"></h5>
                    <br/>
                  <ul className="search-footer-Menu-list" >
                      <li>
                        <img width="50" src="http://res.cloudinary.com/easywaya/image/upload/v1535530819/uvunelogo2_ayfgrq.png"/>
                      </li>
                      <li>
                        <img width="50" src="https://res.cloudinary.com/easywaya/image/upload/v1524426443/12829476_1065330896870118_4143080475571245991_o_qh9gzs.jpg"/>
                      </li>  
                  </ul> 
              </div>
            </div>
           
          </div>
          
     
    </footer>
    <div className="search-footer-body-sub">
              Copyright ©Uvune. 2009-2018 All rights reserved. Uvune is a trademark of Uvune Corporation.
    </div>











           </div>     

    )

}






}

export default Search;





// WEBPACK FOOTER //
// ./src/component/search/search.js